// services/userManagement.js
import http from "./http";


// ✅ Common methods
const commonAPI = {
  get: async (url, params = {}) => {
    const { data } = await http.get(url, { params });
    return data;
  },

  post: async (url, payload = {}) => {
    const { data } = await http.post(url, payload);
    return data;
  },

  put: async (url, payload = {}) => {
    const { data } = await http.put(url, payload);
    return data;
  },

  delete: async (url) => {
    const { data } = await http.delete(url);
    return data;
  },
};

export default commonAPI;
